/* LPA Sunless attribute draft cards/compare (internal review). Marker: lpa-sunless-attr-draft-pills-20260811 */
(function () {
  function init(root) {
    if (!root || root.dataset.lpaDraftReady === '1') return;
    root.dataset.lpaDraftReady = '1';

    var state = {
      band: 'all',
      form: 'all',
      fragrance: 'all',
      face: 'all',
      skin: 'all',
      selected: [],
      pillHighlights: {},
      compareOpen: false,
      tableOpen: false
    };

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-lpa-card]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lpa-row]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-lpa-filter]'));
    var countEl = root.querySelector('[data-lpa-count]');
    var emptyEl = root.querySelector('[data-lpa-empty]');
    var strip = root.querySelector('[data-lpa-compare-strip]');
    var stripItems = root.querySelector('[data-lpa-compare-items]');
    var comparePanel = root.querySelector('[data-lpa-compare-panel]');
    var compareGrid = root.querySelector('[data-lpa-compare-grid]');
    var tablePanel = root.querySelector('[data-lpa-table-panel]');
    var tableToggle = root.querySelector('[data-lpa-table-toggle]');
    var openCompareBtn = root.querySelector('[data-lpa-open-compare]');
    var clearCompareBtn = root.querySelector('[data-lpa-clear-compare]');
    var resetBtn = root.querySelector('[data-lpa-reset]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-lpa-pill]'));
    var maxSelect = 4;

    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function pillKey(pill) {
      return (
        normalize(pill.getAttribute('data-pill-dim')) +
        '::' +
        normalize(pill.getAttribute('data-pill-value'))
      );
    }

    function syncPillHighlights() {
      pills.forEach(function (pill) {
        var active = !!state.pillHighlights[pillKey(pill)];
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function itemMatches(el) {
      var band = normalize(el.getAttribute('data-band'));
      var form = normalize(el.getAttribute('data-form'));
      var fragrance = normalize(el.getAttribute('data-fragrance'));
      var face = normalize(el.getAttribute('data-face'));
      var skin = normalize(el.getAttribute('data-skin'));

      if (state.band !== 'all' && band !== state.band) return false;
      if (state.form !== 'all' && form !== state.form) return false;
      if (state.fragrance !== 'all' && fragrance !== state.fragrance) return false;
      if (state.face !== 'all' && face !== state.face) return false;
      if (state.skin !== 'all' && skin.indexOf(state.skin) === -1) return false;
      return true;
    }

    function findCard(handle) {
      return cards.find(function (card) {
        return card.getAttribute('data-handle') === handle;
      });
    }

    function syncChipActive() {
      chips.forEach(function (chip) {
        var group = chip.getAttribute('data-lpa-filter');
        var value = normalize(chip.getAttribute('data-value'));
        var active = state[group] === value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function ensureChipCountEl(chip) {
      var countEl = chip.querySelector('[data-lpa-chip-count]');
      if (countEl) return countEl;

      var labelEl = chip.querySelector('[data-lpa-chip-label]');
      if (!labelEl) {
        labelEl = document.createElement('span');
        labelEl.setAttribute('data-lpa-chip-label', '');
        while (chip.firstChild) {
          labelEl.appendChild(chip.firstChild);
        }
        chip.appendChild(labelEl);
      }

      countEl = document.createElement('span');
      countEl.className = 'lpa-sunless-draft__chip-count';
      countEl.setAttribute('data-lpa-chip-count', '');
      chip.appendChild(countEl);
      return countEl;
    }

    function countForFilter(group, value) {
      var previous = state[group];
      state[group] = value;
      var total = 0;
      cards.forEach(function (card) {
        if (itemMatches(card)) total += 1;
      });
      state[group] = previous;
      return total;
    }

    function syncChipCounts() {
      chips.forEach(function (chip) {
        var group = chip.getAttribute('data-lpa-filter');
        var value = normalize(chip.getAttribute('data-value'));
        if (!group) return;
        var countEl = ensureChipCountEl(chip);
        countEl.textContent = String(countForFilter(group, value));
      });
    }

    function syncSelectButtons() {
      cards.forEach(function (card) {
        var handle = card.getAttribute('data-handle');
        var selected = state.selected.indexOf(handle) !== -1;
        card.classList.toggle('is-selected', selected);
        var btn = card.querySelector('[data-lpa-select]');
        if (btn) {
          btn.classList.toggle('is-active', selected);
          btn.textContent = selected ? 'Selected' : 'Compare';
          btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }
      });
    }

    function renderCompareStrip() {
      if (!strip || !stripItems) return;
      if (state.selected.length === 0) {
        strip.classList.remove('is-visible');
        stripItems.innerHTML = '';
        if (comparePanel) comparePanel.classList.remove('is-open');
        state.compareOpen = false;
        return;
      }

      strip.classList.add('is-visible');
      stripItems.innerHTML = '';
      state.selected.forEach(function (handle) {
        var card = findCard(handle);
        if (!card) return;
        var title = card.getAttribute('data-title') || handle;
        var chip = document.createElement('div');
        chip.className = 'lpa-sunless-draft__compare-chip';
        chip.innerHTML =
          '<span></span><button type="button" aria-label="Remove From Compare">×</button>';
        chip.querySelector('span').textContent = title;
        chip.querySelector('button').addEventListener('click', function () {
          toggleSelect(handle, false);
        });
        stripItems.appendChild(chip);
      });

      if (openCompareBtn) {
        openCompareBtn.textContent =
          state.compareOpen ? 'Hide Compare' : 'Compare ' + state.selected.length;
      }
    }

    function renderComparePanel() {
      if (!comparePanel || !compareGrid) return;
      if (!state.compareOpen || state.selected.length === 0) {
        comparePanel.classList.remove('is-open');
        return;
      }
      comparePanel.classList.add('is-open');
      compareGrid.innerHTML = '';

      var selectedCards = state.selected
        .map(function (handle) {
          return findCard(handle);
        })
        .filter(Boolean);

      var attrRows = [
        { label: 'Form', attr: 'data-form-label' },
        { label: 'Shade', attr: 'data-shade-label' },
        { label: 'Time', attr: 'data-time-label' },
        { label: 'Guide Color', attr: 'data-guide-label' },
        { label: 'Fragrance', attr: 'data-fragrance-label' },
        { label: 'Skin Type', attr: 'data-skin-label' },
        { label: 'Face And Body', attr: 'data-face-label' },
        { label: 'Key Benefits', attr: 'data-benefits-label' }
      ];

      var table = document.createElement('table');
      table.className = 'lpa-sunless-draft__compare-table';

      var thead = document.createElement('thead');
      var headRow = document.createElement('tr');
      var corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = 'Attribute';
      headRow.appendChild(corner);
      selectedCards.forEach(function (card) {
        var th = document.createElement('th');
        th.scope = 'col';
        th.textContent = card.getAttribute('data-title') || card.getAttribute('data-handle') || '';
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      table.appendChild(thead);

      var tbody = document.createElement('tbody');
      attrRows.forEach(function (rowDef) {
        var tr = document.createElement('tr');
        var th = document.createElement('th');
        th.scope = 'row';
        th.textContent = rowDef.label;
        tr.appendChild(th);
        selectedCards.forEach(function (card) {
          var td = document.createElement('td');
          td.textContent = card.getAttribute(rowDef.attr) || '—';
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      compareGrid.appendChild(table);
      comparePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (card) {
        var show = itemMatches(card);
        card.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });
      rows.forEach(function (row) {
        row.classList.toggle('is-hidden', !itemMatches(row));
      });
      if (countEl) {
        countEl.textContent = visible + ' of ' + cards.length + ' products shown';
      }
      if (emptyEl) {
        emptyEl.classList.toggle('is-visible', visible === 0);
      }
      syncChipActive();
      syncChipCounts();
      syncSelectButtons();
      renderCompareStrip();
      renderComparePanel();
    }

    function toggleSelect(handle, force) {
      var idx = state.selected.indexOf(handle);
      var shouldSelect = typeof force === 'boolean' ? force : idx === -1;
      if (shouldSelect) {
        if (idx !== -1) return;
        if (state.selected.length >= maxSelect) {
          state.selected.shift();
        }
        state.selected.push(handle);
      } else if (idx !== -1) {
        state.selected.splice(idx, 1);
      }
      syncSelectButtons();
      renderCompareStrip();
      if (state.selected.length === 0) {
        state.compareOpen = false;
      }
      renderComparePanel();
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var group = chip.getAttribute('data-lpa-filter');
        var value = normalize(chip.getAttribute('data-value'));
        if (!group) return;
        // All: always select All (no toggle-off). Other chips: toggle on/off → All when off.
        if (value === 'all') {
          state[group] = 'all';
        } else if (state[group] === value) {
          state[group] = 'all';
        } else {
          state[group] = value;
        }
        applyFilters();
      });
    });

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-lpa-select]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        toggleSelect(card.getAttribute('data-handle'));
      });
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var key = pillKey(pill);
        if (state.pillHighlights[key]) {
          delete state.pillHighlights[key];
        } else {
          state.pillHighlights[key] = true;
        }
        syncPillHighlights();
      });
    });

    if (clearCompareBtn) {
      clearCompareBtn.addEventListener('click', function () {
        state.selected = [];
        state.compareOpen = false;
        syncSelectButtons();
        renderCompareStrip();
        renderComparePanel();
      });
    }

    if (openCompareBtn) {
      openCompareBtn.addEventListener('click', function () {
        if (state.selected.length === 0) return;
        state.compareOpen = !state.compareOpen;
        renderCompareStrip();
        renderComparePanel();
      });
    }

    if (tableToggle && tablePanel) {
      tableToggle.addEventListener('click', function () {
        state.tableOpen = !state.tableOpen;
        tablePanel.classList.toggle('is-open', state.tableOpen);
        tableToggle.textContent = state.tableOpen ? 'Hide Data Table' : 'Show Data Table';
        tableToggle.setAttribute('aria-expanded', state.tableOpen ? 'true' : 'false');
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state.band = 'all';
        state.form = 'all';
        state.fragrance = 'all';
        state.face = 'all';
        state.skin = 'all';
        applyFilters();
      });
    }

    applyFilters();
  }

  function boot() {
    document.querySelectorAll('[data-lpa-sunless-draft]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
